export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle strokeOpacity=".7" stroke="#FFF" strokeWidth="2" cx="24" cy="24" r="23" />
                <path d="m33.528 26.872-12.233 7.56a3 3 0 0 1-4.577-2.553V16.761a3 3 0 0 1 4.577-2.552l12.233 7.56a3 3 0 0 1 0 5.103z" fill="#FFF" />
            </g>
        </svg>
    );
}
